import WebApp from '@twa-dev/sdk';

export const twa = {
  isInsideTelegram: (): boolean => {
    return typeof window !== 'undefined' && !!window.Telegram?.WebApp;
  },

  init: () => {
    WebApp.ready();
    WebApp.expand();
    WebApp.enableClosingConfirmation();
    WebApp.requestFullscreen();
    if (WebApp.isVersionAtLeast('7.7')) {
      WebApp.disableVerticalSwipes();
    }
  },

  getInitData: () => {
    return WebApp.initData;
  },

  getUser: () => {
    return WebApp.initDataUnsafe.user;
  },

  getStartParam: (): string | undefined => {
    return WebApp.initDataUnsafe.start_param;
  },

  showAlert: (message: string) => {
    WebApp.showAlert(message);
  },

  showConfirm: (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      WebApp.showConfirm(message, (confirmed: boolean) => {
        resolve(confirmed);
      });
    });
  },

  setHeaderColor: (color: string) => {
    WebApp.setHeaderColor(color as 'bg_color' | 'secondary_bg_color' | `#${string}`);
  },

  setBackgroundColor: (color: string) => {
    WebApp.setBackgroundColor(color as 'bg_color' | 'secondary_bg_color' | `#${string}`);
  },

  close: () => {
    WebApp.close();
  },

  openLink: (url: string) => {
    WebApp.openLink(url);
  },

  openTelegramLink: (url: string) => {
    WebApp.openTelegramLink(url);
  },

  openInvoice: (url: string, callback: (status: string) => void) => {
    WebApp.openInvoice(url, callback);
  },

  hapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => {
      if (!WebApp.isVersionAtLeast('6.9')) return;
      WebApp.HapticFeedback.impactOccurred(style);
    },
    notificationOccurred: (type: 'error' | 'success' | 'warning') => {
      if (!WebApp.isVersionAtLeast('6.9')) return;
      WebApp.HapticFeedback.notificationOccurred(type);
    },
    selectionChanged: () => {
      if (!WebApp.isVersionAtLeast('6.9')) return;
      WebApp.HapticFeedback.selectionChanged();
    },
  },

  mainButton: {
    show: () => WebApp.MainButton.show(),
    hide: () => WebApp.MainButton.hide(),
    setText: (text: string) => WebApp.MainButton.setText(text),
    onClick: (callback: () => void) => WebApp.MainButton.onClick(callback),
    offClick: (callback: () => void) => WebApp.MainButton.offClick(callback),
    showProgress: () => WebApp.MainButton.showProgress(),
    hideProgress: () => WebApp.MainButton.hideProgress(),
    enable: () => WebApp.MainButton.enable(),
    disable: () => WebApp.MainButton.disable(),
  },

  backButton: {
    show: () => WebApp.BackButton.show(),
    hide: () => WebApp.BackButton.hide(),
    onClick: (callback: () => void) => WebApp.BackButton.onClick(callback),
    offClick: (callback: () => void) => WebApp.BackButton.offClick(callback),
  },
};
